import React, { PureComponent } from 'react';
import T from 'prop-types';
import parseFB from 'arts/config/parseFB';
import PinIt from 'arts/components/Social/pin_it';

import * as Classes from './styles.module.scss';

export default class Share extends PureComponent {
  static propTypes = {
    imageUrl: T.string,
    description: T.string,
    href: T.string
  };

  componentDidMount() {
    parseFB(this.fbScope);
  }

  componentDidUpdate() {
    parseFB(this.fbScope);
  }

  render() {
    const { imageUrl, description, href } = this.props;

    return (
      <div className={ Classes.share } ref={ (r) => { this.fbScope = r; } }>
        <div>
          <PinIt
            href={ href }
            imageUrl={ imageUrl }
            description={ description }
          />
        </div>

        <div
          className="fb-like"
          data-href={ href }
          data-layout="button_count"
          data-send="false"
          data-show-faces="false"
          data-width="450"
        />
      </div>
    );
  }
}
